import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Field from '../../components/Field';
import DayPicker, { DAY_PICKER_MODE } from '../../components/DayPicker';
import NavBar from '../../components/NavBar';
import InfoDescription from '../../components/InfoDescription';
import Price, { CURRENCY } from '../../components/Price';
import Table from '../../components/Table';
import DateFormat from '../../components/DateFormat';
import { RepositoryContext } from '../../store/RepositoryProvider';
import API from '../../server/api';
import log from '../../utils/logger';
import NewCollection from './new_collection';
import Modal from '../../components/Modal';
import Badge, {BADGE_TYPE} from "../../components/Badge";

const Collections = () => {
  const {t} = useTranslation(['common', 'collection']);

  const repository = useContext(RepositoryContext);

  const [range, setRange] = useState({ from: new Date(), to: new Date() });
  const [totalAmount, setTotalAmount] = useState(0);
    const [collections, setCollections] = useState([]);
    const [collection, setCollection] = useState({});

  const [showNewCollectionModal, setShowNewCollectionModal] = useState(false);

  const handleCloseNewCollectionModal = useCallback(() => {
    loadCollections();
    setShowNewCollectionModal(false);
  }, []);

  const openCollection = (collection) => {
      setCollection(collection);
      setShowNewCollectionModal(true);
  }

  const loadCollections = useCallback(async () => {
    repository.list(API.collectors.collections, { fromDate: DateFormat.Request({ date: range ? range.from : null }), toDate: DateFormat.Request({ date: range ? range.to : null }) }).then((rows) => {
      rows.sort((a, b) => a.date < b.date ? 1 : (a.date > b.date ? -1 : 0));
      setCollections(rows);
      setTotalAmount(rows.reduce((amount, collection) => amount + collection.amount, 0));
    }).catch((e) => {
      log.error(e);
      setCollections([]);
      setTotalAmount(0);
    });
  }, [range]);

  useEffect(() => {
    loadCollections();
  }, [range]);

  return (
    <div className="trip-app">
      <NavBar title={(
        <>
          {t('collection:collections.title')}
            <span className="title-disabled position-relative" style={{paddingLeft: '20px', top: '-3px'}} onClick={() => loadCollections()}>
               <svg xmlns="http://www.w3.org/2000/svg" className="icon" viewBox="0 0 397.037 397.037" fill="#ccc">
                    <path d="M336.875,190.616c-18.765,0-34.035,15.264-34.035,34.035c0,57.514-46.783,104.315-104.315,104.315 c-57.517,0-104.318-46.802-104.318-104.315c0-45.252,28.727-84.358,70.283-98.527v12.439c0,11.181,5.503,21.65,14.727,28.021 c5.716,3.942,12.397,6.02,19.314,6.02c4.08,0,8.095-0.718,11.926-2.152l1.117-0.478l2.18-1.048l1.051-0.553l87.958-51.557 c11.541-5.72,18.963-17.606,18.963-30.52c0-12.91-7.422-24.809-18.963-30.517L214.804,4.224l-1.033-0.555l-2.144-1.021 l-1.099-0.465C206.686,0.729,202.644,0,198.524,0c-6.992,0-13.694,2.089-19.326,6.02c-9.211,6.35-14.715,16.822-14.715,28.021 v21.605C84.8,71.535,26.133,142.118,26.133,224.657c0,95.056,77.327,172.38,172.383,172.38c95.059,0,172.389-77.324,172.389-172.38 C370.904,205.88,355.64,190.616,336.875,190.616z"/>
                </svg>
            </span>
        </>
      )}/>
        <div className="trip-app-body">
            <Field title={t('collection:collections.dates')}>
                <DayPicker.Input mode={DAY_PICKER_MODE.RANGE} selected={range} onChange={setRange}/>
            </Field>

            <table className="info-table mb-0">
                <tbody>
                <tr>
                    <td>
                        <InfoDescription description={t('collection:collections.total')}>
                            <Price currency={CURRENCY.RUB} value={totalAmount}/>
                        </InfoDescription>
                    </td>
                </tr>
                </tbody>
            </table>

            <Table cols={3}>
                {collections.map((collection, i) => (
                    <Table.Row key={i} delim={true} className="pb-2">
                        <div className="collection-row"
                             onClick={() => collection?.status === 'pending' ? openCollection(collection) : null}>
                            <InfoDescription description={<>{t('collection:collections.cashier')} {collection.user.profile.fullName}</>} >
                  <div className="collection-row_header">
                      <DateFormat.DateTimeSmall date={collection.date} tz={true} />
                      <div className="collection-row_badge">
                          {collection?.status === 'pending' && (
                              <Badge type={BADGE_TYPE.WARN}>
                                  {t(`collection:collection_status.pending`)}
                              </Badge>
                          )}
                          {collection?.status === 'rejected' && (
                              <Badge type={BADGE_TYPE.ERROR}>
                                  {t(`collection:collection_status.rejected`)}
                              </Badge>
                          )}
                          <Badge type={BADGE_TYPE.INFO}>
                              <Price currency={CURRENCY.RUB} value={collection.amount}/>
                          </Badge>
                      </div>
                  </div>
                </InfoDescription>
              </div>
            </Table.Row>
          ))}
        </Table>

        <Modal show={showNewCollectionModal} onHide={handleCloseNewCollectionModal}>
          <Modal.Header closeButton>
          </Modal.Header>
          <Modal.Body>
            {showNewCollectionModal && <NewCollection selectedCollection={collection} onCancel={handleCloseNewCollectionModal} />}
          </Modal.Body>
          <Modal.Footer>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  )
}

export default Collections;